import React, { FC } from 'react';
import { Checkbox } from '@cld/checkbox';
import { useOptions } from '../../../../../../selectors';

export interface LabelInputProps {
  onClick: () => void,
}

const inputProps = {
  'data-test': 'custom-preset-select-checkbox',
};

export const SelectInput: FC<LabelInputProps> = ({ onClick }) => {
  const { selectedPresets } = useOptions();

  return (
    <Checkbox
      value={selectedPresets.custom}
      onClick={onClick}
      inputProps={inputProps}
    />
  );
};
